import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2';
import axios from 'axios';
import { format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller } from "react-hook-form";

export default function AdvertisementAdd() {
    const [dataEdit, setDataEdit] = useState({});
    const [TotalPay, setTotalPay] = useState(0);
    const [endDate, setEndDate] = useState(dataEdit.endDate);
    const [MainPrice, setPrice] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [uniqueArray, setuniqueArray] = useState([...Array(32).fill('')]);
    const [count, setCount] = useState(0);
    const [inputValues, setInputValues] = useState([...Array(32).fill('')]);
    const user = useSelector(state => state.user);
    const [yearlySelected, setYearlySelected] = useState('')
    const showTime =format(new Date(), 'MMddyyyyHis');
    const location = useLocation();
    const id = decodeURIComponent(location.pathname.split('/advertisement-edit/')[1]);
    
    const navigate = useNavigate();
    useEffect(() => {
        console.log('ID from URL:', id); 
        async function getGarage() {

            const data = await axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetAdbyId', id: id })
                .then(response => {
                    if(response.data.status===true){
                    return response.data.data;
                    }else{
                        Swal.fire({
                            icon: 'info',
                            title: response.data.message,
                        });
                        navigate('/')
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
            const imagesURL = {
                url: data.picture ? `${process.env.REACT_APP_UPLOAD_URL + data.picture}?time=${showTime}` : '',
                rotationAngle: data.pictureA ? data.pictureA : 0,
            };
            setFileURL([imagesURL]);
            console.log('data.ZipCodes', data.ZipCodes)
            setInputValues(data.ZipCodes.length !== 0 ? data.ZipCodes : [...Array(32).fill('')])
            setuniqueArray(data.ZipCodes.length !== 0 ? data.ZipCodes : [...Array(32).fill('')])
            setDataEdit(data);
        }
        if (id) {
            getGarage(id);
        }
    }, [id]);

    const [fileURL, setFileURL] = useState([]);
    
    const {
        control, register, handleSubmit,
        formState: { errors }, getValues,
        watch, reset
    } = useForm();

    useEffect(() => {
        const defaultZipCodes = inputValues;

        // Convert defaultZipCodes array to an object with keys zipcode0, zipcode1, etc.
        const zipCodeFields = defaultZipCodes.reduce((acc, zipCode, index) => {
            acc[`ZipCodes${index}`] = zipCode;
            return acc;
        }, {});
        if (dataEdit) {
            reset({
                businessName: dataEdit.businessName || '',
                businessLicense: dataEdit.businessLicense || '',
                businessURL: dataEdit.businessURL || '',
                ...zipCodeFields
            });
        }
    }, [dataEdit, reset]);

    const zipCodes = watch('zipCodes') || inputValues;



    const profile_complete = useSelector(state => state.user.profile_complete);
    useEffect(() => {
        if (profile_complete != true) {
            navigate('/edit_user');
            Swal.fire({
                icon: 'info',
                title: 'Please complete your profile first.',
            });
        }
    }, [profile_complete]);



    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}?action=getPrice`)
            .then(response => {
                setPrice(response.data.data.price)
                setDiscount(response.data.data.yearlyDiscount)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });

    }, [])



    const handleInputChange = (index, event) => {
        const newValue = Number(event.target.value);

        if (newValue && inputValues.some(item => item === newValue)) {
            event.target.classList.add('red-border');
        } else {
            event.target.classList.remove('red-border');
        }
        const newInputValues = [...inputValues];
        newInputValues[index] = newValue;

        setInputValues(newInputValues);
        const uniqueArray = [...new Set(newInputValues)];
        console.log(uniqueArray)
        const nonEmptyValues = uniqueArray.filter((item) => item !== '');
        setCount(nonEmptyValues.length);

        setuniqueArray(nonEmptyValues)
        console.log('newInputValues', nonEmptyValues)
    };
    const calculatePercentage = (part, whole) => {
        if (whole === 0) {
            return 0;
        } else {
            const percentage = (part / 100) * whole;
            const mainvalue = part - percentage
            return mainvalue.toFixed(1);
        }
    }

    const handleImageChange = (event) => {
        const { files } = event.target;
        console.log('adPicture')
        if (files) {
            console.log('rotatedImage', files)
            const images = event.currentTarget.files[0];

            if (typeof (images) === 'object') {
                var reader = new FileReader();

                reader.onload = function (e) {

                    const rotatedImage = {
                        url: e.target.result,
                        rotationAngle: 0,
                    };

                    setFileURL([rotatedImage])
                };
                reader.readAsDataURL(images);
            }
        }
    }

    const handleChange = () => {
        const PaymentType = dataEdit.PaymentType;
        const oneMonthLater = new Date(getValues("startDate"));
        if (PaymentType === 'YearlyBilling' && uniqueArray.length !== 0) {
            console.log('uniqueArray', uniqueArray)
            if (MainPrice && MainPrice > 0) {
                const thisdates = (getValues("startDate") ? new Date(oneMonthLater.setMonth(oneMonthLater.getMonth() + 12)) : '')
                setEndDate(thisdates)
                const discount = document.getElementById('discount').value;
                const MainPriceValue = `${MainPrice * count}`;
                const MainPriceYearly = MainPriceValue * 12;
                const calculate = calculatePercentage(MainPriceYearly, discount)
                setYearlySelected(
                    <div>
                        <p className='pay2'>Your Total is ${MainPriceValue} * {12} = ${MainPriceYearly} annually.</p>
                        <p className='pay'>You got {discount}% discount on annual payment. Your total amount due is ${calculate}.</p>
                        {getValues("startDate") ? (<p className='EndDate'> Advertisement End Date will be {format(thisdates, 'MM/dd/yyyy')}</p>) : ''}
                        <p className="pay-total">NOTE: You can't add more ZipCodes. If you want to add additional ZipCodes, you'll need to create a new advertisement.But you can edit the existing Zipcodes</p>

                    </div>
                )
                setTotalPay(calculate);
            }
        } else if (PaymentType === 'MonthlyBilling' && uniqueArray.length !== 0) {
            console.log('222')
            const thisdates = (getValues("startDate") ? new Date(oneMonthLater.setMonth(oneMonthLater.getMonth() + 1)) : '')
            setEndDate(thisdates)
            if (MainPrice && MainPrice > 0) {
                setYearlySelected(
                    <div>
                        <p className='pay2'>You have to pay ${MainPrice * count} each month.</p>
                        {getValues("startDate") ? (<p className='EndDate'>  Advertisement End Date will be {format(thisdates, 'MM/dd/yyyy')}</p>) : ''}
                        <p className="pay-total">NOTE: You can't add more ZipCodes. If you want to add additional ZipCodes, you'll need to create a new advertisement.But you can edit the existing Zipcodes</p>
                    </div>
                )
                setTotalPay(MainPrice * count);
            }
        } else {
            console.log('333')
            setYearlySelected('')
        }
    };
    useEffect(() => {
        handleChange();
    }, [count, uniqueArray]);

    const rotateImage = (index) => {
        console.log('fileURL', fileURL)
        setFileURL(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[index].rotationAngle = (updatedImages[index].rotationAngle + 90) % 360;
            return updatedImages;
        });
    };

    const removeImage = (index) => {
        setFileURL([]);
    };

    const openImageModal = (e) => {
        e.preventDefault();
        document.getElementById('imagePreviewModal').classList.add('show');
        document.getElementById('imagePreviewModal').style.display = 'block';
    };


    const closeModal = (event) => {
        event.preventDefault();
        // setPreviewImages([]);
        document.getElementById('imagePreviewModal').classList.remove('show');
        document.getElementById('imagePreviewModal').style.display = 'none';
    };


    const onSubmit = (data) => {
        console.log('inputValues', inputValues)
        console.log('uniqueArray', uniqueArray)
        if (inputValues.length !== uniqueArray.length) {
            alert("The value is already present. Please enter a unique value.");
        } else {
            const formData = new FormData();
            formData.append('action', 'UpdateAd');
            formData.append('id', id);
            formData.append('businessName', data.businessName);
            formData.append('businessLicense', data.businessLicense);
            (data.businessURL !== dataEdit.businessURL && formData.append('businessURL', data.businessURL));
            formData.append('ZipCodes', uniqueArray);
            formData.append('TotalPay', TotalPay);
            formData.append('PaymentType', dataEdit.PaymentType);
            formData.append('picture', data.adPicture ? data.adPicture : '');
            formData.append('pictureA', fileURL ? fileURL[0].rotationAngle : 0);
            formData.append('ownerID', user.uid);
            formData.append('ownerEmail', user.email);
            formData.append('userStatus', 1);
            axios.post(`${process.env.REACT_APP_API_URL}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then(response => {
                    console.log(response.data.status);
                    Swal.close();
                    if (response.data.status === true) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Advertiment Updated',
                        }).then(() => {
                            navigate('/advertisement');
                        })
                    } else {
                        Swal.fire(
                            'Oops...m',
                            `Something went wrong creating the garage ${response.data.message}`,
                            'error'
                        );
                    }
                })
                .catch(error => {
                    Swal.close();
                    Swal.fire(
                        'Oops...m',
                        `Something went wrong creating the garage ${error}`,
                        'error'
                    );
                });
        }
    };

    return (
        <section className="page-content half-map sec-padding">
            <div className="container">
                <div className="sec-title row justify-content-center">
                    <h3>Advertise with GarageXY</h3>
                </div>
                <div className="col-md-10 mx-auto">
                    <div className="card AddressView">
                        <div className="card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>

                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="businessName"> Business Name <span className="text-danger">*</span></label>
                                    <div className="col-md-8 d-flex position-relative">
                                        <input name="businessName" type="text"
                                            className="form-control" {...register("businessName", { required: true })}
                                            defaultValue={dataEdit.businessName}
                                        />
                                        {errors.businessName &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Business Name is required!</span>
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="businessLicense"> Business License <span className="text-danger">*</span></label>
                                    <div className="col-md-8 d-flex position-relative">
                                        <input name="businessLicense" type="text"
                                            className="form-control" {...register("businessLicense", { required: true })}
                                            defaultValue={dataEdit.businessLicense}
                                        />
                                        {errors.businessLicense &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Business Licenseis required!</span>
                                            </span>
                                        }
                                    </div>
                                </div>
                        
                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="adPicture"> Advertise image <span className="text-danger">*</span></label>
                                    <div className="col-md-8 d-flex position-relative justify-content-between">
                                        <Controller
                                            control={control}
                                            name="adPicture"
                                            // rules={{ required: true }}
                                            render={({ field }) => (
                                                <>
                                                    <input
                                                        id="adPicture"
                                                        type="file"
                                                        className="form-file form-control"
                                                        accept=".jpg, .png, jpeg"
                                                        onChange={(e) => {
                                                            handleImageChange(e);
                                                            field.onChange(e.target.files[0]);
                                                        }}
                                                        ref={field.ref}
                                                    />
                                                    <label htmlFor="adPicture" className="btn btn-primary btn-lg">Choose a File</label>
                                                </>
                                            )}
                                        />

                                        {fileURL.length > 0 && <button className="btn btn-primary btn-lg" onClick={openImageModal}>File Preview</button>}

                                        {errors.adPicture &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Advertise image is required!</span>
                                            </span>
                                        }

                                    </div>
                                </div>

                                {fileURL.length > 0 &&
                                    <div className="modal fade" id="imagePreviewModal" tabIndex="-1" role="dialog">
                                        <div className="modal-dialog modal-xxl" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Image Preview</h5>
                                                    <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                                                        <span aria-hidden="true"></span>
                                                    </button>
                                                </div>
                                                <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                    <div className="row">
                                                        <header style={{ height: '250px' }}>
                                                            <div className="container-fluid">
                                                                <div className="row align-items-center">
                                                                    <div className="col-md-4 mb-2 mb-md-0 text-dark text-decoration-none  col-sm-12 col-xs-12">
                                                                        <a href="/" title="">
                                                                            <img src="https://garagexy.com/API/images/garage-logo.png " alt="logo" /></a>
                                                                    </div>
                                                                    <div className="col-md-3 col-sm-12 col-xs-12 text-center">
                                                                        <nav><ul><li className="loginButton"><a href="#" className="Iconbig"><i className="la la-user "></i>
                                                                            <i className="la la-chevron-down "></i></a>
                                                                        </li></ul>
                                                                        </nav>
                                                                    </div>
                                                                    <div className="col-md-5 text-end col-sm-12 col-xs-12">
                                                                        <div className="text-center imgtinyDiv">
                                                                            <img src={fileURL[0].url} alt={`Preview`} style={{ transform: `rotate(${fileURL[0].rotationAngle}deg)` }} className="img-fluid mb-2 previewImg" />
                                                                            <div className="d-flex justify-content-around">
                                                                                <i onClick={() => rotateImage(0)} className="la la-refresh"></i>
                                                                                <i onClick={() => removeImage(0)} className="la la-trash"></i>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </header>
                                                    </div>
                                                </div>

                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closeModal}>Done</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="businessURL"> Business URL <span className="text-danger">*</span></label>
                                    <div className="col-md-8 d-flex position-relative">
                                        <input name="businessURL" type="text"
                                            className="form-control" {...register("businessURL", { required: true })}
                                            defaultValue={dataEdit.businessURL}
                                        />

                                        {errors.businessURL &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Business URL is required!</span>
                                            </span>
                                        }
                                    </div>
                                    <div className="col-md-4"></div>
                                    {dataEdit.approveStatus == 1 &&
                                        <small className="col-md-8 text-danger ">
                                            if you want to change business url and advertisement image , then it will again sending for approval
                                        </small>
                                    }
                                </div>
                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="ZipCodes"> ZipCodes  <span className="text-danger">*</span><br /><br />
                                        <a className='btn btn-primary'
                                            href={`https://www.unitedstateszipcodes.org/`} target="_blank"
                                        >Zipcode Map </a>
                                    </label>
                                    <div className="col-md-8 row zipcodeall ">
                                        {inputValues.map((value, index) => (
                                            <div className="col-md-4 position-relative" key={index}>
                                                <Controller
                                                    control={control}
                                                    name={`ZipCodes${index}`}
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <input
                                                            className="form-control"
                                                            id={`ZipCodes${index}`}
                                                            type="number"
                                                            value={field.value || (value === 0 ? "" : value)}
                                                            onChange={(e) => {
                                                                handleInputChange(index, e);
                                                                field.onChange(e.target.value);
                                                                handleChange();
                                                            }}
                                                            ref={field.ref}
                                                        />
                                                    )}
                                                />

                                                {errors[`ZipCodes${index}`] &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">ZipCode {index + 1} is required!</span>
                                                    </span>
                                                }

                                            </div>
                                        ))}


                                    </div>
                                    <div>
                                        <input type="hidden" id='MainPrice' value={count ? count * MainPrice : MainPrice} />
                                        <input type="hidden" id='discount' value={discount} />

                                        <div style={{ whiteSpace: 'pre-line' }}>
                                            {Array.isArray(uniqueArray) && uniqueArray.filter((item) => item !== '').map((item, index) => (
                                                <div key={index}>
                                                    <p className="zip-price">ZipCode: {item}&nbsp;| &nbsp;Price: ${MainPrice}</p>
                                                </div>
                                            ))}
                                            <>
                                                {count > 0 && <p className="total-new-zipcode">Total Zipcode: {count}</p>}
                                                {/* {count > 0 && <p className="pay-total">You have to Pay Total: ${count * MainPrice}</p>} */}
                                            </>
                                            <p className="pay-total"></p>
                                        </div>
                                    </div>

                                </div>


                                <div className="form-group text-center">
                                    <button type="submit" className="btn btn-primary btn-lg" >Update Advertisement</button>
                                </div>

                            </form>
                        </div>

                    </div>
                </div>
            </div >
        </section >
    )
}
